////////LIBRARY/////////
import React from 'react'
import styled from 'styled-components'
import { useSelector, shallowEqual, useDispatch } from 'react-redux'
import { isNull, isUndefined, find } from 'lodash'
import { bindActionCreators } from 'redux'
///////COMPONENTS///////
import TableNested from '../../../components/Table/components/TableNested'
import userPrivileges from '../../../constants/PrivilegesList'
import { useHistory } from 'react-router-dom'
import { uriList } from '../../../routings/settings/RouteList'
import ActionsTable from '../../../components/ActionsTable'
import { salesHistoryManagerActionCreators } from '../../../store/actions'
/////////ASSETS/////////
import seePromotionIcon from '../../../assets/icones/global/view.svg'

//////STYLED//////
const SalesHistoryManagerNestedWrapper = styled.td`
	display: ${(props) => (props.isVisible ? 'table-cell' : 'none')};
	border-top: 1px solid ${(props) => props.theme.colors.table.borderTable};
	& > div {
		max-width: calc(100vw - 350px);
		position: sticky;
		left: 100px;
		min-width: max-content;
	}
	& > div:before {
		content: '';
		height: 100%;
		width: 1px;
		position: absolute;
		left: -1px;
		box-shadow: 3px 0px 3px #00000029;
		z-index: 20;
		top: 0px;
	}
	& > div:after {
		content: '';
		height: 100%;
		width: 1px;
		position: absolute;
		right: -1px;
		box-shadow: -3px 0px 3px #00000029;
		z-index: 20;
		top: 0px;
	}
	& > div > div {
		min-width: max-content;
	}
`
//////STYLED//////

const SalesHistoryManagerNested = (props) => {
	const { translations, user } = useSelector(
		(state) => ({
			translations: state.languages.translations,
			user: state.user,
		}),
		shallowEqual
	)

	let history = useHistory()

	///////////////////////////////// HANDLE ///////////////////////////////////////

	const handleSeePromotion = (row) => {
		actionsSalesHistoryManager.setPromotionNumber(row)
		history.push(`${uriList.prices}${uriList.scheduledPromoManager}`)
	}

	///////////////////////////////// CONFIG ///////////////////////////////////////

	const config = {
		name: '',
		isInNestedTable: true,
	}

	const actionsSalesHistoryManager = bindActionCreators(salesHistoryManagerActionCreators, useDispatch())

	const currency = props.row.currency.symbol

	const columns = [
		{
			dataHook: 'itemFamily',
			headerName: translations['page__transactionsHistory__admin__salesTable_expand_tableHeader_itemFamilly'],
			sortable: true,
			isAuthorize: true,
			toTranslate: true,
		},
		{
			dataHook: 'itemBrand',
			headerName: translations['page__transactionsHistory__admin__salesTable_expand_tableHeader_itemBrand'],
			sortable: true,
			isAuthorize: true,
		},
		{
			dataHook: 'itemLabelToDisplay',
			headerName: translations['page__transactionsHistory__admin__salesTable_expand_tableHeader_itemLabel'],
			sortable: true,
			isAuthorize: true,
		},
		{
			dataHook: 'isAccessory',
			headerName: translations['page__transactionsHistory__admin__salesTable_expand_tableHeader_isAccessory'],
			sortable: true,
			isAuthorize: true,
			component: (props) => (props.row.isAccessory ? translations['common__text__yes'] : translations['common__text__no']),
		},
		{
			dataHook: 'amountItem',
			headerName: translations['page__transactionsHistory__admin__salesTable_expand_tableHeader_itemAmount'],
			sortable: true,
			isAuthorize: true,
			component: (props) => (!isNull(props.row.amountItem) ? `${props.row.amountItem}${currency}` : `-`),
		},
		{
			dataHook: 'vatRateItem',
			headerName: translations['page__transactionsHistory__admin__salesTable_expand_tableHeader_itemTva'],
			sortable: true,
			isAuthorize: true,
			component: (props) => (!isNull(props.row.vatRateItem) ? `${props.row.vatRateItem}%` : '-'),
		},
		{
			dataHook: 'withDeposit',
			headerName: translations['page__transactionsHistory__admin__salesTable_expand_tableHeader_itemWithConsignation'],
			sortable: true,
			isAuthorize: true,
			component: (props) => (props.row.withDeposit ? translations['common__text__yes'] : translations['common__text__no']),
		},
		{
			dataHook: 'amountDeposit',
			headerName: translations['page__transactionsHistory__admin__salesTable_expand_tableHeader_itemDepositAmount'],
			sortable: true,
			isAuthorize: true,
			component: (props) => (!isNull(props.row.amountDeposit) ? `${props.row.amountDeposit}${currency}` : `-`),
		},
		{
			dataHook: 'vatRateDeposit',
			headerName: translations['page__transactionsHistory__admin__salesTable_expand_tableHeader_itemDepositTva'],
			sortable: true,
			isAuthorize: true,
			component: (props) => (!isNull(props.row.vatRateDeposit) ? `${props.row.vatRateDeposit}%` : '-'),
		},
		{
			dataHook: 'promotionCampaignId',
			headerName: translations['page__transactionsHistory__admin__salesTable_expand_tableHeader_itemWithPromotion'],
			sortable: true,
			isAuthorize: true,
			component: (props) => (props.row.withPromo ? props.row.promotionCampaignId : '-'),
		},
		{
			dataHook: 'labelLockerIn',
			headerName: translations['page__transactionsHistory__admin__salesTable_expand_tableHeader_lockerDoorIn'],
			sortable: true,
			isAuthorize: true,
			component: (props) => (props.row.labelLockerIn ? props.row.labelLockerIn : '-'),
		},
		{
			dataHook: 'labelLockerOut',
			headerName: translations['page__transactionsHistory__admin__salesTable_expand_tableHeader_lockerDoorOut'],
			sortable: true,
			isAuthorize: true,
			component: (props) => (props.row.labelLockerOut ? props.row.labelLockerOut : '-'),
		},
		{
			action: true,
			isFixed: false,
			component: ActionsTable,
			rest: {
				paperActionsList: [
					{
						//icon: seePromotionIcon,
						clickAction: (row) => {
							handleSeePromotion(row)
						},
						isVisible: (row) =>
							row.withPromo.translationKey === translations['common__text__yes'] &&
							!isUndefined(find(user.identity.rolePrivileges.privileges, (o) => o.label === userPrivileges.view[5])),
					},
				],
			},
		},
	]

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<SalesHistoryManagerNestedWrapper colSpan={props.colspan} isVisible={props.stateToggleNested}>
			<div>
				<div>{<TableNested inputColumns={columns} inputData={props.row.salesOrderLines} inputConfig={config} />}</div>
			</div>
		</SalesHistoryManagerNestedWrapper>
	)
}

SalesHistoryManagerNested.propTypes = {}

SalesHistoryManagerNested.defaultPropTypes = {}

export default SalesHistoryManagerNested
